
import { logger } from "@/lib/logger";

/**
 * Common response format for auth email service operations
 */
export interface AuthEmailResponse {
  success: boolean;
  error?: string;
  rateLimited?: boolean;
  id?: string;
}

/**
 * Login information for new login notification
 */
export interface LoginInfo {
  time: string;
  ip: string;
  device: string;
}

/**
 * Utility to handle email service errors consistently
 */
export const handleEmailServiceError = (
  error: any,
  context: {
    operation: string;
    email: string;
    [key: string]: any;
  }
): AuthEmailResponse => {
  // Check if this is a rate limit error
  if (
    error.message?.toLowerCase().includes('rate limit') ||
    error.status === 429 ||
    error.message?.includes('email rate limit exceeded')
  ) {
    logger.warn({
      message: `${context.operation} rate limit reached`,
      context: { email: context.email, ...context }
    });
    
    return { 
      success: false, 
      error: "For security reasons, we limit how often emails can be sent. Please wait a few minutes before trying again.", 
      rateLimited: true 
    };
  }

  // Log and return a general error
  logger.error({
    message: `Failed to ${context.operation}`,
    error: error instanceof Error ? error : new Error(String(error)),
    context: { email: context.email, ...context }
  });
  
  return {
    success: false,
    error: error.message || `Failed to ${context.operation}`
  };
};
